export default __webpack_public_path__ + "static/media/referPad.94398b2f.jpg";